import {parsePhoneNumber} from 'libphonenumber-js/max';

/**
 * Validates if it's a valid and mobile phone number
 */
export const validateMobilePhoneNumber = (
  phoneNumber: string
): {
  isMobilePhoneNumber: boolean;
  isValidPhoneNumber: boolean;
} => {
  try {
    // Parse the phone number
    const parsedPhoneNumber = parsePhoneNumber(phoneNumber);

    // Check if it's valid
    if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
      // Check if it's a mobile phone number
      if (parsedPhoneNumber.getType() === 'MOBILE') {
        // Mobile
        return {
          isMobilePhoneNumber: true,
          isValidPhoneNumber: true,
        };
      } else {
        // Not mobile but valid
        return {
          isMobilePhoneNumber: false,
          isValidPhoneNumber: true,
        };
      }
    } else {
      // Not valid
      return {
        isMobilePhoneNumber: false,
        isValidPhoneNumber: false,
      };
    }
  } catch (error) {
    // Log
    console.debug('Could not validate the phone number.', error);

    return {
      isMobilePhoneNumber: false,
      isValidPhoneNumber: false,
    };
  }
};
